export default __webpack_public_path__ + "static/media/450.a3bc4811.png";